import { ChevronDown } from "lucide-react"
import type { ComponentProps } from "react"
import { cn } from "@/lib/utils"
export function NativeSelect({
  className,
  children,
  ...props
}: ComponentProps<"select">) {
  return (
    <span className="relative block min-w-0">
      <select
        data-slot="native-select"
        {...props}
        className={cn("w-full appearance-none pr-10", className)}
        style={{ ...props.style, appearance: "none", paddingRight: "2.5rem" }}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-current opacity-70"
      />
    </span>
  )
}
